/* Fruit & Feelings — theme behavior
   Cart (AJAX + Section Rendering API), drawer, variant pills, blinking eyes, form validation. */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes) || { root: '/' };
  var root = routes.root || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Scrolling marquee ----------------
     Clone the single seed chunk until one "group" is at least as wide as the
     container, then duplicate that group so a -50% translate loops seamlessly.
     Re-run on resize so only enough repeats to fill the width are rendered
     (no stacking on narrow screens). Speed stays constant via px/s duration. */
  var SPEED = 80; // px per second

  function setupMarquee() {
    var marquee = $('.ff-marquee');
    var track = marquee && $('.ff-marquee__track', marquee);
    if (!track) return;

    // Remember the original seed chunk once, then rebuild from it each time.
    if (!track.__seedHTML) {
      var seed = $('.ff-marquee__chunk', track);
      if (!seed) return;
      track.__seedHTML = seed.outerHTML;
    }
    track.innerHTML = track.__seedHTML;

    var containerWidth = marquee.clientWidth;
    var firstChunk = $('.ff-marquee__chunk', track);
    var chunkWidth = firstChunk.getBoundingClientRect().width;
    if (!chunkWidth || !containerWidth) return;

    // Fill one group so it spans at least the container width.
    var perGroup = Math.max(1, Math.ceil(containerWidth / chunkWidth));
    for (var i = 1; i < perGroup; i++) {
      track.appendChild(firstChunk.cloneNode(true));
    }

    // Duplicate the group so translateX(-50%) lands on an identical frame.
    var groupHTML = track.innerHTML;
    track.innerHTML = groupHTML + groupHTML;

    var groupWidth = perGroup * chunkWidth;
    track.style.setProperty('--ff-marquee-duration', (groupWidth / SPEED).toFixed(2) + 's');
    marquee.classList.add('ff-marquee--animate');
  }

  var marqueeTimer = null;
  function onResize() {
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(setupMarquee, 150);
  }

  /* ---------------- Newsletter popup ----------------
     Shows once per visitor after a delay, or on desktop exit-intent — whichever
     comes first. Remembered in localStorage. If the customer form just posted
     successfully (Shopify reloads with ?customer_posted=true), show it straight
     away so the subscriber sees the thank-you. */
  var POPUP_SEEN_KEY = 'ff_popup_seen';

  function setupPopup() {
    var popup = $('#ff-popup');
    if (!popup) return;

    var justSubscribed = /[?&]customer_posted=true/.test(window.location.search);

    function stored() {
      try { return window.localStorage.getItem(POPUP_SEEN_KEY); }
      catch (e) { return null; }
    }
    function remember() {
      try { window.localStorage.setItem(POPUP_SEEN_KEY, '1'); } catch (e) {}
    }

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      popup.classList.remove('ff-popup--closed');
      popup.setAttribute('aria-hidden', 'false');
      remember();
      var email = popup.querySelector('input[type="email"]');
      if (email && !justSubscribed) { try { email.focus(); } catch (e) {} }
    }
    function close() {
      popup.classList.add('ff-popup--closed');
      popup.setAttribute('aria-hidden', 'true');
      remember();
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.classList.contains('ff-popup--closed')) close();
    });

    if (justSubscribed) { open(); return; }   // show the thank-you state
    if (stored()) return;                      // already seen — don't nag

    var delay = (parseInt(popup.getAttribute('data-popup-delay'), 10) || 18) * 1000;
    var timer = setTimeout(open, delay);

    // Desktop exit-intent: cursor leaves toward the top of the viewport
    function onLeave(e) {
      if (e.clientY <= 0) { clearTimeout(timer); open(); document.removeEventListener('mouseout', onLeave); }
    }
    document.addEventListener('mouseout', onLeave);
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = null;

  function openDrawer() {
    drawer = drawer || $('#ff-cart-drawer');
    if (drawer) {
      drawer.classList.remove('is-hidden');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeDrawer() {
    drawer = drawer || $('#ff-cart-drawer');
    if (drawer) {
      drawer.classList.add('is-hidden');
      document.body.style.overflow = '';
    }
  }

  /* Re-render the drawer contents + header count using the Section Rendering API. */
  function refreshCart() {
    return fetch(root + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#ff-cart-contents');
        var current = $('#ff-cart-contents');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch(root + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCount(cart.item_count); })
      .catch(function (e) { console.error('[FF] cart refresh failed', e); });
  }

  function updateCount(n) {
    $all('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function addToCart(id, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function (e) {
        console.error('[FF] add to cart failed', e);
        if (e && e.description) alert(e.description);
      });
  }

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .catch(function (e) { console.error('[FF] cart change failed', e); });
  }

  /* ---------------- Delegated events ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Open cart
    if (t.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    // Close cart (scrim or ×)
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    // Variant pill
    var pill = t.closest('.ff-pill');
    if (pill && !pill.disabled) {
      e.preventDefault();
      var form = pill.closest('form');
      if (form) {
        $all('.ff-pill', form).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var idInput = form.querySelector('[name="id"]');
        if (idInput && pill.dataset.variantId) idInput.value = pill.dataset.variantId;
      }
      return;
    }

    // Qty stepper / remove inside drawer
    var stepBtn = t.closest('[data-line-change]');
    if (stepBtn) {
      e.preventDefault();
      var line = parseInt(stepBtn.dataset.line, 10);
      var qty = parseInt(stepBtn.dataset.lineChange, 10);
      changeLine(line, qty);
      return;
    }
  });

  // Esc closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------------- Add-to-cart forms ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.matches('[data-add-form]')) {
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(idInput.value, qty);
      return;
    }

    if (form.matches('.ff-newsletter')) {
      var email = form.querySelector('input[type="email"]');
      if (email && !/.+@.+\..+/.test(email.value)) {
        e.preventDefault(); // block obviously-bad emails; valid ones go to Shopify
      }
      return;
    }

    if (form.matches('#ff-wholesale')) {
      var name = form.querySelector('[name="contact[name]"]');
      var wmail = form.querySelector('[name="contact[email]"]');
      var msg = form.querySelector('[name="contact[body]"]');
      var errBox = form.querySelector('[data-form-error]');
      var err = '';
      if (name && !name.value.trim()) err = 'Please add your name.';
      else if (wmail && !/.+@.+\..+/.test(wmail.value)) err = 'Please add a valid email address.';
      else if (msg && !msg.value.trim()) err = 'Tell us a little about what you’re thinking.';
      if (err) {
        e.preventDefault();
        if (errBox) { errBox.textContent = err; errBox.classList.remove('is-hidden'); }
      }
      return;
    }
  });

  // Clear wholesale error on input
  document.addEventListener('input', function (e) {
    var form = e.target.closest('#ff-wholesale');
    if (form) {
      var errBox = form.querySelector('[data-form-error]');
      if (errBox) errBox.classList.add('is-hidden');
    }
  });

  /* ---------------- Product image carousel ----------------
     Native scroll-snap track; arrows + dots drive it by whole-slide widths.
     Each slide is 100% of the track, so slide i sits at i * clientWidth. */
  function setupCarousels() {
    $all('[data-carousel]').forEach(function (car) {
      var track = $('[data-carousel-track]', car);
      if (!track) return;
      var slides = $all('.ff-carousel__slide', track);
      if (slides.length < 2) return;
      var dots = $all('[data-carousel-dot]', car);

      function currentIndex() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }

      var n = slides.length;
      var prev = $('[data-carousel-prev]', car);
      var next = $('[data-carousel-next]', car);
      // Cyclical: wrap past either end (last → first, first → last).
      if (prev) prev.addEventListener('click', function () { goTo((currentIndex() - 1 + n) % n); });
      if (next) next.addEventListener('click', function () { goTo((currentIndex() + 1) % n); });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); }); });

      // Sync active dot to scroll position (rAF-throttled).
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var idx = currentIndex();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      });
    });
  }

  /* ---------------- Init ---------------- */
  function init() {
    setupMarquee();
    setupCarousels();
    setupPopup();
    drawer = $('#ff-cart-drawer');
    window.addEventListener('resize', onResize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
